import { useDeferredFadeSwap } from '@src/quince-components/src/hooks/useDeferredFadeSwap'

import type { ReviewItemProps } from '../reviewItem'
import type { RefObject } from 'react'

interface ReviewFadeValue {
  reviews: ReviewItemProps[]
  count: number
}

export interface UseReviewFadeTransitionParams {
  isLoading: boolean | undefined
  isFadeEnabled: boolean
  fadeDurationMs: number
  reviews: ReviewItemProps[]
  count: number
}

export interface UseReviewFadeTransitionResult {
  /** True until the first load completes; used to gate the LoaderWrapper spinner for groupC. */
  isFirstLoad: boolean
  isContainerVisible: boolean
  preservedMinHeight: number | undefined
  displayedCount: number
  displayedReviews: ReviewItemProps[]
  containerRef: RefObject<HTMLDivElement>
}

export function useReviewFadeTransition({
  isLoading,
  isFadeEnabled,
  fadeDurationMs,
  reviews,
  count,
}: UseReviewFadeTransitionParams): UseReviewFadeTransitionResult {
  const { displayedValue, isVisible, isFirstTransitionDone, containerRef, preservedMinHeight } =
    useDeferredFadeSwap<ReviewFadeValue>(
      { reviews, count },
      isLoading,
      // skipFirstTransition=true: the initial spinner covers the first load, so skip the fade there.
      { enabled: isFadeEnabled, durationMs: fadeDurationMs, skipFirstTransition: true },
    )

  return {
    isFirstLoad: !isFirstTransitionDone,
    isContainerVisible: isVisible,
    preservedMinHeight,
    displayedCount: displayedValue.count,
    displayedReviews: displayedValue.reviews,
    containerRef,
  }
}
